module.exports = __webpack_public_path__ + "static/logo-83f14979adcd668cbaf8a6caef213e50.svg";